import clsx from "clsx";
import React from "react";
import { BaseCardSanityImage } from "../BaseCard/BaseCard";
import { PartialSanityImageType } from "../SanityImage";
import { Price } from "../types/price";
import styles from "./SuiteCard.module.scss";
import { PriceItem } from "../Prices/PriceItem/PriceItem";

type Props = {
  price?: Price;
  priceLabel: string;
  isSelected: boolean;
};
export const SuiteCard: React.FC<React.PropsWithChildren<Props>> = ({
  price,
  priceLabel,
  isSelected
}) => {
  return (
    <div className={clsx(styles.card, { [styles.isSelected]: isSelected })}>
      <div className={styles.body}>
        <div className={styles.label}>{priceLabel}</div>
        <div className={styles.price}>
          {price ? (
            <PriceItem
              price={price}
              variant="normal"
              layout="column"
              priceType="primary"
              className={styles.priceItem}
              priceClassName={styles.priceItemValue}
              chipBackgroundColor={isSelected ? "white" : "neutral05"}
              showFareLabel={false}
            />
          ) : (
            "-"
          )}
        </div>
      </div>
    </div>
  );
};

type SuiteCardImageProps = {
  image: PartialSanityImageType;
  name: string;
  isSelected: boolean;
};
export const SuiteCardImage: React.FC<
  React.PropsWithChildren<SuiteCardImageProps>
> = ({ image, name, isSelected }) => {
  return (
    <div className={clsx(styles.card, { [styles.isSelected]: isSelected })}>
      <BaseCardSanityImage image={image} ratio="card" alt={name} />
    </div>
  );
};
